import React from "react"
import classNames from "classnames"
import * as styles from "./stlyes.module.css"

export const Button = ({
  className,
  loading,
  onClick,
  children,
  disabled = false,
}: {
  children: JSX.Element
  onClick: () => void
  className: string
  loading: boolean
  disabled?: boolean
}) => {
  return (
    <button
      className={classNames(styles.button, className, {
        [styles.loading]: loading,
        [styles.disabled]: loading || disabled,
      })}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {children}
    </button>
  )
}
